import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Divider,
  Drawer,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ExpandMore,
  moment,
} from "../../Collections/Imports";
import GlobalDateRangePicker from "../../Components/CommonComponents/GlobalDateRangePicker";
import "./style.css";
import GlobalMultiSelect from "../../Components/CommonComponents/GlobalMultiSelect";
import { useDispatch, useSelector } from "react-redux";
import { updateChannelFilterData } from "../../Store/ChannelModule/filter";
import { updatePubOptions } from "../../Store/PublisherModule/filter";

import {
  useApiCallMutation,
  useGetApiCallQuery,
} from "../../Services/ApiCallService";
import {
  publisherModuleApiEndPoints,
  coreAPIEndsPoints,
} from "../../Config/APIsEndpoints";
import { updateLabelOptions } from "../../Store/Global/LabelOptions";
import { updateManagerOptions } from "../../Store/Global/ManagerOptions";
import { updateTypeOptions } from "../../Store/Global/TypeOptions";
import { updateBuyesOptions } from "../../Store/Global/BuyersOptions";
import { click } from "@testing-library/user-event/dist/click";
import CustomButton from "../../Components/CommonComponents/GlobalButton";
import { allPubData } from "../../Store/PublisherModule";
import GlobalDropdown from "../../Components/CommonComponents/GlobalDropdown";
import { updateMappingFilterData } from "../../Store/ChannelMappingModule/filter";

const MappingFilters = (props) => {
  const {
    setOpen,
    isOpen,
    defaultValues,
    isEditMode,
    defaultChannel,
    ClearFilters,
  } = props;
  const previousFilterData = useSelector(
    (state) => state?.mappingFilterSession?.filterData
  );

  const mappingData = useSelector(
    (state) => state?.MappingData?.data?.sourceChannelMappings
  );

  //create list of unique sources
  // Extract unique sources
  const uniqueSources = [...new Set(mappingData.map((item) => item.source))];

  const sourcesOptionList = uniqueSources.map((source, index) => ({
    value: source,
    label: source,
  }));
  const channelLabels = useSelector(
    (state) => state?.channelLabels?.tableData?.channelLabel
  );
  const channelLabelOptions = [{}];
  const dispatch = useDispatch();

  const AllFilterLength = useSelector(
    (state) => state?.channelFilterSession.filterData
  );

  const pubOptions = useSelector(
    (state) => state.publisherData?.data?.allPubData?.publishers
  );

  // Extract unique publishers along with pubUniqueId
  const uniquePublishers = pubOptions.reduce((unique, current) => {
    if (!unique[current.publisherName]) {
      unique[current.publisherName] = current.pubUniqueId;
    }
    return unique;
  }, {});

  const publisherOptionsList = Object.entries(uniquePublishers).map(
    ([name, id]) => ({
      value: id,
      label: name,
    })
  );
  // ====================================================================

  const channelsData = useSelector(
    (state) => state.ChannelData?.data?.channelData?.Channels
  );
  // Extract unique channels along with Id
  const uniqueChannels = channelsData.reduce((unique, current) => {
    if (!unique[current.channelName]) {
      unique[current.channelName] = current.channelUniqueId;
    }
    return unique;
  }, {});

  const channelOptionsList = Object.entries(uniqueChannels).map(
    ([name, id]) => ({
      value: id,
      label: name,
    })
  );

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      status: "All",
      channelUniqueId: ["All"],
      pubUniqueId: ["All"],
      publisherNames: ["All"],
    },
    // resolver: yupResolver(validationSchema),
    mode: "all",
  });

  const [selectedDateFilter, setSelectedDateFilter] = useState({
    startDate: new Date("July 01, 2020"),
    endDate: new Date(),
    key: "selection",
  });

  //***********FORM SUBMISSION ********//
  const onFormSubmit = (data) => {
    const filterData = {
      status: data?.status,
      source: data?.source,
      pubUniqueId: data?.pubUniqueId,
      sourceWebsite: ["all"],
      channelUniqueId: data?.channelUniqueId,
      fromDate: data?.dateRange
        ? moment(data?.dateRange[0]?.startDate).startOf("day").toDate()
        : moment(selectedDateFilter?.startDate).startOf("day").toDate(),
      toDate: data?.dateRange
        ? moment(data?.dateRange[0]?.endDate).endOf("day").toDate()
        : new Date(),
    };

    dispatch(updateMappingFilterData(filterData));
    setOpen(false);
  };

  // Call setFormValue after initialization
  useEffect(() => {
    if (previousFilterData && Object.keys(previousFilterData)?.length) {
      setFormValue(previousFilterData);
    }
  }, [previousFilterData]);

  // Set Form Value
  const setFormValue = (data) => {
    const dateRange = {
      startDate: new Date(data?.fromDate),
      endDate: data?.toDate,
      key: "selection",
    };

    setValue("status", data?.status, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("source", data?.source, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("pubUniqueId", data?.pubUniqueId, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("channelUniqueId", data?.channelUniqueId, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    setValue("dateRange", dateRange, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
  };
  //Push new option All
  const AllOptions = { label: "All", id: 1, value: "All" };

  const [statusOptions, setStatusOptions] = useState([
    { label: "Active", value: "true" },
    { label: "Disabled", value: "false" },
  ]);

  // Pushing the AllOptions object into the statusOptions array
  useEffect(() => {
    setStatusOptions((prevOptions) => [AllOptions, ...prevOptions]);
  }, []);

  return (
    <>
      <Drawer
        anchor={"right"}
        open={isOpen}
        onClose={() => setOpen(false)}
        sx={{
          [`& .MuiDrawer-paper`]: {
            boxSizing: "border-box",
            top: "15px",
            borderRadius: "16px",
            maxWidth: "500px",
            width: "100%",
          },
        }}
      >
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            spacing={{ xs: 1, sm: 2 }}
            direction="row"
            useFlexGap
            flexWrap="wrap"
            justifyContent={"space-between"}
          >
            <Box marginBottom={"15px"}>
              <Typography component="h6" variant="h6" fontWeight={600}>
                Filters
              </Typography>
            </Box>
            <Box marginBottom={"15px"}>
              <Typography
                component="h7"
                variant="h7"
                fontWeight={200}
                style={{ cursor: "pointer" }}
                onClick={ClearFilters}
              >
                Clear All
              </Typography>
            </Box>
          </Stack>

          <Divider
            sx={{
              mb: "20px",
            }}
          />

          <Box component={"form"} className="accordionGrid">
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "status"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Status{" "}
                  {AllFilterLength?.status && AllFilterLength?.status != "" && (
                    <span className="count-style">
                      <p>1</p>
                    </span>
                  )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalDropdown
                  control={control}
                  size="small"
                  name="status"
                  options={statusOptions}
                  required
                  error={!!errors.status}
                  helperText={errors.status?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "source"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Source{" "}
                  {AllFilterLength?.source &&
                    AllFilterLength?.source?.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength?.source?.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="source"
                  label=""
                  options={sourcesOptionList || []}
                  required
                  error={!!errors.source}
                  helperText={errors.source?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "publisher"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Publisher{" "}
                  {AllFilterLength?.pubUniqueId &&
                    AllFilterLength?.pubUniqueId?.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength?.pubUniqueId?.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="pubUniqueId"
                  label=""
                  options={publisherOptionsList}
                  required
                  error={!!errors.pubUniqueId}
                  helperText={errors.pubUniqueId?.message}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "channel"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">
                  Channel{" "}
                  {AllFilterLength?.channelUniqueId &&
                    AllFilterLength?.channelUniqueId.length > 0 && (
                      <span className="count-style">
                        <p>{AllFilterLength?.channelUniqueId.length}</p>
                      </span>
                    )}
                </Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                {/* <GlobalDropdown control={control} name="label" options={[]} /> */}
                <GlobalMultiSelect
                  control={control}
                  size="small"
                  name="channelUniqueId"
                  label=""
                  options={channelOptionsList || []}
                  required
                  error={!!errors.channelUniqueId}
                  helperText={errors.channelUniqueId?.message}
                />
              </AccordionDetails>
            </Accordion>
            {/* </Grid> */}

            {/* <Grid item xs={12}> */}
            <Accordion
              className="accordionWrapper"
              defaultExpanded={
                defaultChannel == "created"
                  ? true
                  : defaultChannel == "all"
                  ? true
                  : false
              }
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                className="accordionSummary"
              >
                <Typography className="filterTitle">Create Date</Typography>
              </AccordionSummary>

              <AccordionDetails sx={{ backgroundColor: "#e0e0e05e" }}>
                <Controller
                  name="dateRange"
                  control={control}
                  render={({ field }) => (
                    <GlobalDateRangePicker
                      defaultRange={{
                        startDate: new Date(),
                        endDate: new Date(),
                        key: "selection",
                      }}
                      {...field}
                    />
                  )}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
        </Box>
        <Box
          sx={{
            pt: "1rem",
            pr: "1rem",
            pl: "1rem",
          }}
        >
          <Stack
            direction="row"
            component={Box}
            useFlexGap
            flexWrap="wrap"
            justifyContent={"flex-end"}
            bottom={0}
            marginTop={"1rem"}
          >
            <Box marginBottom={"15px"} marginRight={"5px"}>
              <CustomButton
                color="#3a5396"
                // label="Add Campaign"
                label="Apply Filter"
                onClick={handleSubmit(onFormSubmit)}
              />
            </Box>
            <Box marginBottom={"15px"}>
              <CustomButton
                labelColor="#7a7870"
                variant="outlined"
                color="white"
                label="Close"
                onClick={() => setOpen(false)}
              />
            </Box>
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default MappingFilters;
